/**
 * EI Menu Touch Fix
 * Fix iPad/tablette : le menu dropdown se fermait trop vite au tap.
 * Sur appareils tactiles, 1er tap sur parent = ouvre dropdown.
 * 2e tap sur le même lien parent = navigue vers la page de la catégorie.
 * Tap sur une sous-catégorie = navigue.
 * Tap ailleurs = ferme tous les dropdowns.
 */
(function() {
  'use strict';

  // Detecter si l'appareil supporte hover (souris) — sinon = touch only
  var hasHover = window.matchMedia('(hover: hover)').matches;
  if (hasHover) return; // desktop : hover CSS fait le job, pas besoin de fix

  function init() {
    var dropdowns = document.querySelectorAll('#header .nav-item.dropdown, .nav-item.dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(function(item) {
      // Le lien parent (Antipasti, Pasta, etc.)
      var parentLink = item.querySelector(':scope > a.nav-link, :scope > a.menu_lv1');
      if (!parentLink) return;

      parentLink.addEventListener('click', function(e) {
        // Si le dropdown n'est pas déjà ouvert, on l'ouvre et on bloque la navigation
        if (!item.classList.contains('ei-touch-open')) {
          e.preventDefault();
          // Fermer les autres dropdowns ouverts
          dropdowns.forEach(function(other) {
            if (other !== item) other.classList.remove('ei-touch-open');
          });
          item.classList.add('ei-touch-open');
        }
        // Sinon (déjà ouvert) : on laisse le clic naviguer normalement
      });
    });

    // Tap ailleurs → ferme tous les dropdowns
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-item.dropdown')) {
        dropdowns.forEach(function(d) { d.classList.remove('ei-touch-open'); });
      }
    });

    // Tap sur sous-catégorie → ferme (la navigation se fera après)
    document.querySelectorAll('.dropdown-menu a').forEach(function(subLink) {
      subLink.addEventListener('click', function() {
        dropdowns.forEach(function(d) { d.classList.remove('ei-touch-open'); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
